// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Open Sans", sans-serif;
  color: #070f1c;
}
body .com-page {
  height: 100vh;
}
body .com-page-cover {
  z-index: -1;
  object-fit: cover;
  object-position: bottom;
}
body .com-page-top-sec-logo {
  position: absolute;
  top: 1.3580246914vw;
  width: 9.62vw;
  transform: none;
  left: 20px;
  z-index: 1;
}
body .com-page .form-box {
  width: 560px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.91);
  border: 6px solid #e7d993;
  padding: 50px 60px;
  max-width: 90%;
}
body .com-page .form-box-logo {
  width: 100px;
}
body .com-page .form-box-btn {
  font-size: 20px;
  background-color: #21fdc2 !important;
  border-radius: 50px;
  border: 2px solid #fff !important;
  color: #070f1c !important;
  min-height: 50px;
  font-weight: 500;
}
body .com-page .form-box-small-text {
  color: #0f2a75 !important;
  font-size: 12px;
}
body .multi-email-label-box {
  border: 1px solid rgba(204, 204, 204, 0.2705882353);
  border-radius: 3px;
  width: 100%;
  padding: 4px 8px;
  display: flex;
  flex-wrap: wrap;
  max-height: 120px;
  overflow-y: auto;
  font-size: 14px;
}
body .single-email-label {
  border: none;
  padding: 3px 6px;
  background: #e8da99;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  margin: 3px 5px 3px 0;
}
body .otp-com-input {
  width: 20%;
  padding: 5px 8px !important;
  text-align: center !important;
}
body input::-webkit-outer-spin-button,
body input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
body .form-design {
  height: 100vh;
  justify-content: center;
  position: relative;
}
body .form-design-bg {
  position: absolute;
  left: 0;
  top: 0;
  object-fit: cover;
}
@media (max-width: 767px) {
  body .form-design-bg {
    object-position: left;
  }
}
body .form-design-inner {
  border-radius: 20px;
  width: 90%;
  max-width: 780px;
  z-index: 1;
  border: 1px solid #e7d993;
}
@media (max-width: 767px) {
  body .form-design-inner {
    border-radius: 15px;
  }
}
body .form-design-inner .dot {
  background-color: rgba(246, 239, 207, 0.5803921569);
  width: 60px;
  height: 60px;
  z-index: -1;
}
body .form-design-inner-left {
  min-height: 400px;
  background-color: rgba(18, 38, 95, 0.6901960784);
  border-radius: 20px 0 0 20px;
}
@media (max-width: 1000px) {
  body .form-design-inner-left {
    min-height: 370px;
  }
}
@media (max-width: 767px) {
  body .form-design-inner-left {
    border-radius: 15px 15px 0 0;
    min-height: auto;
    padding: 20px;
  }
}
body .form-design-inner-left:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  backdrop-filter: blur(10px);
  z-index: -1;
  border-radius: 20px 0 0 20px;
}
@media (max-width: 767px) {
  body .form-design-inner-left:after {
    border-radius: 15px 15px 0 0;
  }
}
body .form-design-inner-left .dot {
  left: -15px;
  top: -26px;
  width: 50px;
  height: 50px;
}
body .form-design-inner-left img {
  width: 110px;
}
@media (max-width: 767px) {
  body .form-design-inner-left img {
    width: 90px;
  }
}
body .form-design-inner-right {
  padding: 20px 50px;
  border-radius: 0 20px 20px 0;
  background-color: rgba(245, 238, 202, 0.39);
}
@media (max-width: 767px) {
  body .form-design-inner-right {
    border-radius: 0 0 15px 15px;
    padding: 25px 30px;
  }
}
body .form-design-inner-right:after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  backdrop-filter: blur(10px);
  z-index: -1;
  border-radius: 0 20px 20px 0;
}
@media (max-width: 767px) {
  body .form-design-inner-right:after {
    border-radius: 0 0 15px 15px;
  }
}
body .form-design-inner-right .dot {
  right: -25px;
  bottom: -25px;
  background: linear-gradient(45deg, rgba(151, 146, 116, 0.1294117647), rgba(231, 217, 147, 0.1490196078));
}
@media (max-width: 767px) {
  body .form-design-inner-right .dot {
    right: 0px;
    bottom: -25px;
  }
}
body .form-design-inner-right-inner-heading {
  color: #12265f;
  font-weight: 700;
  font-size: 26px;
}
body .form-design-inner-right-inner-input {
  display: flex;
  align-items: center;
  position: relative;
}
body .form-design-inner-right-inner-input input {
  background-color: #dee6ff;
  border: 1px solid rgba(204, 204, 204, 0.2705882353);
  border-radius: 5px;
  height: 35px;
  padding: 0 43px;
}
@media (max-width: 767px) {
  body .form-design-inner-right-inner-input input {
    padding: 0 34px;
  }
}
body .form-design-inner-right-inner-input input:focus {
  border-color: #e7d896 !important;
  box-shadow: 0 0 0 0.25rem rgba(231, 216, 150, 0.4);
  outline: none;
}
body .form-design-inner-right-inner-input-left-icon {
  position: absolute;
  left: 15px;
}
@media (max-width: 767px) {
  body .form-design-inner-right-inner-input-left-icon {
    left: 10px;
  }
}
body .form-design-inner-right-inner-input-password-icon {
  right: 15px;
}
body .form-design-inner-right-inner-btn {
  min-width: 100px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 2px;
}
body .form-design-inner-right-inner-link {
  font-size: 12px;
  color: #12265f;
}
body .main-page-row {
  display: flex;
}
body .main-page-row-right {
  width: 100%;
  background-color: #f7f7f7;
}
@media (min-width: 1200px) {
  body .main-page-row-right {
    width: calc(100vw - 250px);
  }
}
body .main-page-body {
  padding: 0 20px;
  min-height: calc(100% - 53px);
}
body .main-page-body-scroll {
  height: 100vh;
  overflow-y: auto;
  background-color: #f7f7f7;
  padding-top: 90px;
}
body .main-page .golden-bg {
  background-color: #e7d993;
}
body .main-page .golden-text {
  color: #e7d993;
}
body .main-page .resize-none {
  resize: none;
}
body .main-page .gray-bg {
  background-color: #a9b0b3;
}
body .main-page .main-gray {
  color: #a9b0b3;
}
body .main-page .com-card-box {
  padding: 1.25rem;
  box-shadow: transparent 0px 2px 4px, rgba(0, 0, 0, 0.1) 0px 2px 6px;
  margin-bottom: 1.25rem;
  border-radius: 0.25rem;
  background: #fff;
}
@media (max-width: 1200px) {
  body .main-page .com-card-box {
    padding: 10px;
  }
}
body .com-heading {
  font-size: 15px !important;
  font-weight: 700;
  text-transform: uppercase;
  color: #0f1114;
  margin-bottom: 18px;
}
@media (max-width: 767px) {
  body .com-heading {
    font-size: 11px !important;
  }
}
body .after-before-none:before,
body .after-before-none:after {
  content: none !important;
}
body .golden-heading {
  -webkit-text-stroke: 1px rgb(189, 166, 108);
  font-size: 40px;
  color: #e7d993;
}
body .scroll-none::-webkit-scrollbar {
  display: none;
}
body .com-input-field {
  border: 1px solid rgba(204, 204, 204, 0.2705882353);
  border-radius: 3px;
  display: block;
  width: 100%;
  height: 40px;
  padding: 2px 12px;
  font-size: 14px;
}
body .com-input-field:focus {
  border-color: #e7d896 !important;
  box-shadow: 0 0 0 0.25rem rgba(231, 216, 150, 0.4);
  outline: none;
}
body .com-modal .com-select__control {
  min-width: 80px;
}
@media (max-width: 550px) {
  body .com-modal .com-select__control {
    width: 100%;
  }
}
body .com-select {
  font-size: 14px;
}
body .com-select__control {
  border: 1px solid rgba(204, 204, 204, 0.2705882353) !important;
  min-width: 80px;
}
@media (max-width: 550px) {
  body .com-select__control {
    width: 100px;
  }
}
body .com-select__control--is-focused {
  border-color: #e7d896 !important;
  box-shadow: 0 0 0 0.25rem rgba(231, 216, 150, 0.4);
  outline: none;
}
body .com-select__control .css-1xc3v61-indicatorContainer {
  padding: 4px 4px;
}
body .com-select__indicator-separator {
  display: none;
}
body .com-select__value-container {
  font-size: 14px;
  padding-right: 0;
  white-space: nowrap;
}
@media (max-width: 500px) {
  body .com-select__value-container {
    font-size: 12px;
  }
}
body .com-select__menu-list {
  padding: 0;
}
body .com-select__option {
  font-size: 14px;
  cursor: pointer;
}
body .com-select__option--is-selected {
  background-color: #e7d993 !important;
  color: #070f1c;
}
body .com-select__option--is-focused {
  background-color: #f0f4ff;
}
body .profile-page-left-user {
  position: relative;
  aspect-ratio: 1/1;
  width: 250px;
  max-width: 65%;
}
body .profile-page-left-user img {
  object-fit: cover;
  border: 1px solid #ededed;
}
body .profile-page-left-user-edit-pencil {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #938989;
  border-radius: 50px;
  padding: 2px;
  cursor: pointer;
}
body .com-datatable {
  position: relative;
}
body .com-datatable-loader {
  z-index: 99;
  background-color: rgba(255, 255, 255, 0.11);
  backdrop-filter: blur(2px);
}
body .com-datatable-loader .spinner-border {
  border-color: #e8da99;
  border-right-color: transparent;
}
body .com-datatable .sc-cyZbyy {
  border: 1px solid #e7d993;
  border-radius: 5px;
  padding: 0 30px 0 8px;
}
body .com-datatable #pagination-previous-page,
body .com-datatable #pagination-next-page {
  background-color: #e7d993;
  border-radius: 4px;
  border: 1px solid #dde1ef;
  height: 33px;
  padding: 0;
  width: 33px;
  border: none;
  margin-left: 10px;
}
body .com-datatable #pagination-previous-page path:first-child,
body .com-datatable #pagination-next-page path:first-child {
  fill: #212529;
}
body .com-datatable #pagination-first-page,
body .com-datatable #pagination-last-page {
  display: none;
}
body .com-datatable .rdt_TableRow:not(:last-of-type) {
  border-bottom: none;
}
body .com-datatable .rdt_TableRow:nth-child(odd) {
  background-color: #f6f8ff;
}
body .com-datatable input[type=checkbox] {
  accent-color: #e7d993;
}
body .com-datatable .rdt_TableCol_Sortable {
  opacity: 1 !important;
}
body .com-datatable .rdt_TableCol_Sortable span {
  opacity: 0.8;
  padding-top: 0;
  padding-bottom: 0;
}
body .com-datatable .rdt_TableCol {
  white-space: nowrap;
  font-weight: 600;
}
body .com-datatable .rdt_TableCell {
  white-space: nowrap;
  padding: 6px 6px;
  font-size: 13px;
}
@media (max-width: 1366px) {
  body .com-datatable .rdt_TableCell {
    font-size: 12px;
  }
}
body .com-datatable .rdt_TableCell > div {
  white-space: pre-line;
  overflow: visible;
  text-align: start;
  width: 100%;
  line-height: 20px;
}
body .com-datatable .cell-tabs {
  width: fit-content;
  border: none;
  margin: 2px 5px;
  background-color: #e7d993;
  border-radius: 3px;
  text-align: center;
  padding: 1px 3px;
  text-transform: capitalize;
}
body .hover-bg:hover {
  background-color: #f0f4ff;
}
body .cursor-pointer {
  cursor: pointer;
}
body .com-btn {
  border-radius: 4px;
  padding: 6px 10px;
  color: #000;
}
body .com-btn-outline {
  border: 1px solid #e7d993;
}
body .golden-border {
  border: 1px solid #e7d993;
}
body .form-control, body .form-select {
  font-size: 13px;
}
body .form-control:focus, body .form-select:focus {
  box-shadow: 0 0 0 0.25rem lch(86.65% 36.43 93.72deg / 0.3);
  border-color: #e7d993;
}
body .form-label {
  font-size: 13px;
}
body .form-check {
  font-size: 13px;
  padding-left: 30px;
}
body .form-check-input {
  border-color: #e7d993 !important;
  box-shadow: none !important;
  width: 15px;
  height: 15px;
  border-radius: 2px !important;
  margin-top: 2px;
  margin-left: -24px !important;
}
body .form-check-input:checked {
  background-color: #e7d993;
  border-color: #e7d993;
}
body .com-table-check-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
body .font-15px {
  font-size: 15px;
}
body .font-13px {
  font-size: 13px;
}
@media (min-width: 500px) {
  body .font-13px {
    font-size: 12px;
  }
}
body .font-12px {
  font-size: 12px;
}
body .font-11px {
  font-size: 11px;
}
body .notification-area-btn {
  border: none;
  padding: 0;
  background-color: transparent;
  position: relative;
  display: block;
}
body .notification-area-btn i {
  color: #fff;
  transition: 0.3s;
}
@media (min-width: 1599px) {
  body .notification-area-btn i {
    font-size: 18px;
  }
}
body .notification-area .dropdown-menu {
  padding: 10px 0;
  width: 300px;
  right: -65px !important;
  box-shadow: 0 4px 8px rgba(147, 147, 147, 0.24);
  border-radius: 3px;
  top: 53px !important;
}
@media (max-width: 991px) {
  body .notification-area .dropdown-menu {
    width: 200px;
    right: -100px !important;
  }
}
body .notification-area-count {
  position: absolute;
  top: 1px;
  right: 4px;
  min-width: 8px;
  height: 8px;
  border-radius: 10px;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
body .notification-area-count:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: #ffb9b9;
  width: 40%;
  height: 40%;
  z-index: -1;
  animation: circlewave 2s linear infinite;
}
@keyframes circlewave {
  0% {
    width: 40%;
    height: 40%;
    opacity: 1;
  }
  75% {
    width: 135%;
    height: 135%;
    opacity: 1;
  }
  100% {
    width: 160%;
    height: 160%;
    opacity: 0;
  }
}
body .notification-area-count-num {
  position: relative;
  background-color: red;
  color: #fff;
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 50%;
  height: 100%;
  justify-content: center;
  padding: 0 3px;
}
body .notification-area-heading {
  margin-bottom: 8px;
  font-size: 20px;
  font-weight: 600;
  padding: 0 0 9px 14px;
  border-bottom: 1px solid #ededed;
}
@media (max-width: 767px) {
  body .notification-area-heading {
    font-size: 15px;
  }
}
body .notification-area-list {
  list-style: none;
  padding: 0;
  height: auto;
  max-height: 230px;
  overflow-y: auto;
}
body .notification-area-list-single {
  margin-bottom: 9px;
  padding: 3px 18px;
  cursor: pointer;
  transition: 0.3s;
}
body .notification-area-list-single:last-child {
  margin-bottom: 0;
}
body .notification-area-list-single-a {
  text-decoration: none;
  color: gray;
}
body .notification-area-list-single-text {
  font-size: 14px;
  margin-bottom: 3px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  white-space: pre-wrap;
  overflow: hidden;
}
@media (max-width: 767px) {
  body .notification-area-list-single-text {
    font-size: 11px;
  }
}
body .notification-area-list-single-foot {
  color: rgb(92, 92, 92);
  font-size: 12px;
  display: flex;
  justify-content: space-between;
}
@media (max-width: 767px) {
  body .notification-area-list-single-foot {
    font-size: 10px;
  }
}
body .notification-area-list-single-foot-user {
  display: flex;
  align-items: center;
  text-transform: capitalize;
}
body .notification-area-list-single-foot-user-icon {
  margin-right: 5px;
}
body .notification-area-no-notification {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(92, 92, 92);
  flex-direction: column;
}
body .notification-area-no-notification i {
  font-size: 50px;
  color: #e7e7e7;
  margin-bottom: 16px;
}
body .notification-area-no-notification-text {
  font-size: 14px;
}
body .analytics-box {
  width: 308px;
  position: relative;
  transition: 0.3s;
  flex-shrink: 0;
}
@media (max-width: 900px) {
  body .analytics-box {
    width: 270px;
  }
}
@media (max-width: 650px) {
  body .analytics-box {
    width: 230px;
  }
}
body .analytics-box:hover {
  transform: translateY(-5px);
  transition: 0.3s;
  z-index: 1;
}
body .analytics-box-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
body .analytics-box-body {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
body .analytics-box-body-show {
  font-weight: 700;
  font-size: 22px;
}
@media (max-width: 1200px) {
  body .analytics-box-body-show {
    font-size: 18px;
  }
}
body .analytics-box-body-chart-box {
  position: relative;
  width: 50%;
}
body .analytics-box-body-chart-box-canvas {
  width: 100%;
  height: 100%;
}
body .analytics-box-body-chart-box-para {
  margin: 3px 0;
  text-align: center;
  font-size: 0.675rem;
  color: #0f1114;
}
body .analytics-box-body-first p {
  font-size: 14px;
  color: #21a321;
}
@media (max-width: 1200px) {
  body .analytics-box-body-first p {
    font-size: 11px;
  }
}
body .analytics-box-heading {
  font-size: 0.875rem;
  color: #0f1114;
}
@media (max-width: 1200px) {
  body .analytics-box-heading {
    font-size: 12px;
    margin-bottom: 9px;
  }
}
body .analytics-box-meter-box {
  height: 5px;
  background-color: #fbf6f6;
  border-radius: 8px;
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
}
@media (max-width: 1200px) {
  body .analytics-box-meter-box {
    height: 2px;
  }
}
body .analytics-box-meter-box-inner {
  background-color: #07a707;
  height: 100%;
  border-radius: 10px;
}
@media (max-width: 767px) {
  body .order-card-box {
    width: 50%;
  }
}
body .golden-btn-respn-show {
  white-space: nowrap;
}
@media (max-width: 567px) {
  body .golden-btn-respn-show {
    font-size: 11px;
    padding: 6px 8px;
  }
}
@media (max-width: 768px) {
  body .res-all-golden-btn {
    margin-top: 10px;
    flex-wrap: wrap;
  }
}
@media (max-width: 567px) {
  body .res-all-golden-btn {
    margin-top: 15px;
  }
}
body .balance-overview-chart-box {
  width: 100%;
}
body .balance-overview-chart-box-canvas {
  width: 100% !important;
}
body .activity-chart-container-box {
  width: 100%;
}
body .activity-chart-container-para {
  margin-top: -20px;
  text-align: center;
  font-size: 0.675rem;
  color: #0f1114;
}
body .orders-container-chart-box {
  height: 300px;
  width: 100% !important;
}
body .exclama-deleteIcon {
  width: 42px;
  height: 42px;
  fill: #FF6961;
}
body .danger-bg {
  background-color: #FF6961 !important;
  color: #fff;
}
body .orange-bg {
  background-color: #fd7e14 !important;
  color: #fff !important;
}
body .assign-bg {
  background-color: #d52662 !important;
  color: #fff !important;
}
body .refund-bg {
  background-color: #673ab7 !important;
  color: #fff !important;
}
body .customercall-bg {
  color: #fff !important;
  background-color: #3f73a2 !important;
}
body .text-white {
  color: #fff !important;
}
body .danger-color {
  color: #ff6961 !important;
}
body .delete-item-modal-dialog {
  width: 350px;
  margin: 0 auto;
  max-width: 90%;
}
body .delete-item-modal-footer-btn {
  border-radius: 20px;
  padding: 5px 15px;
  border: 1px solid #FF6961;
}
body .row-box-respnon-show {
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 767px) {
  body .row-box-respnon-show {
    flex-direction: column;
    gap: 10px;
  }
}
body .tooltip-area {
  position: relative;
  cursor: pointer;
}
body .tooltip-text {
  display: none;
  font-size: 11px;
  background-color: #e7d896;
  border-radius: 5px;
  border: 1px solid #8b792c;
  position: absolute;
  left: 0%;
  top: -20px;
  z-index: 9999;
  width: 100%;
  height: auto;
  text-align: center;
  line-height: 15px;
}
body .location-td {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
}
body .tooltip-area:hover .tooltip-text {
  display: block;
}
body .completeIcon-box {
  width: 42px !important;
  height: 42px !important;
  min-width: 42px;
  display: inline-block;
}
body .completeIcon-box svg {
  fill: #099500;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
body .completeIcon-box svg g {
  fill: #099500;
}
body .booking-complete-footer {
  border-radius: 20px;
  padding: 5px 15px;
  border: 1px solid #099500;
  color: #fff;
}
body .bg-green {
  background-color: #099500 !important;
}
body .green-color {
  color: #099500 !important;
}
body .dateranger {
  border: 1px solid rgba(139, 137, 137, 0.27) !important;
  padding: 6px 8px;
  border-radius: 7px;
  color: #656161;
  font-size: 13px;
  height: 38px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
body .dateranger-icon {
  font-size: 15px;
}
body .dateranger .react-datepicker__input-container > input {
  border: none;
  width: 155px;
  margin-top: 5px;
  outline: none;
}
@media (max-width: 767px) {
  body .dateranger .react-datepicker__input-container > input {
    font-size: 12px;
  }
}
@media (max-width: 500px) {
  body .dateranger .react-datepicker__input-container > input {
    width: 155px;
  }
}
@media (max-width: 400px) {
  body .dateranger .react-datepicker {
    width: 180px;
  }
}
body .dateranger .react-datepicker .react-datepicker__header {
  background-color: #ffffff;
  border-bottom: none;
}
body .dateranger .react-datepicker .react-datepicker__navigation-icon::before {
  border-color: #000;
  right: -2px;
  width: 7px;
  height: 7px;
}
body .react-datepicker__day--keyboard-selected,
body .react-datepicker__month-text--keyboard-selected,
body .react-datepicker__quarter-text--keyboard-selected,
body .react-datepicker__year-text--keyboard-selected {
  border-radius: 1rem;
}
body .react-datepicker__day-name,
body .react-datepicker__day,
body .react-datepicker__time-name {
  width: 18px;
  min-width: 18px;
  font-size: 11px;
  padding: 0px;
  line-height: 19px;
}
body .react-datepicker__current-month,
body .react-datepicker-time__header,
body .react-datepicker-year-header {
  font-size: 14px;
}
body .order-datatable-filter-container {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  align-items: center;
}
@media (max-width: 600px) {
  body .order-datatable-filter-container {
    flex-wrap: wrap;
  }
}
body .custom-modalbackdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Customize the backdrop color and opacity */
  display: flex;
  justify-content: center;
  align-items: center;
}
body .OrderCard-main-container {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  padding: 0;
}
@media (max-width: 767px) {
  body .OrderCard-main-container {
    flex-wrap: wrap;
    gap: 18px;
  }
}
body .OrderCard-width {
  width: 24%;
}
@media (max-width: 767px) {
  body .OrderCard-width {
    width: 48%;
  }
}
@media (max-width: 600px) {
  body .OrderCard-width {
    width: 47%;
  }
}
@media (max-width: 480px) {
  body .OrderCard-width {
    width: 46%;
  }
}
body .BookingCard-width {
  width: 32.5%;
}
@media (max-width: 767px) {
  body .BookingCard-width {
    width: 31%;
  }
}
@media (max-width: 600px) {
  body .BookingCard-width {
    width: 30%;
  }
}
@media (max-width: 480px) {
  body .BookingCard-width {
    width: 99%;
  }
}
body .reminder-history-box {
  height: 150px;
  min-height: 120px;
  overflow: auto;
  border-radius: 3px;
  padding: 3px 6px;
}
body .reminder-history-box-single {
  margin-bottom: 12px;
}
body .reminder-history-box-single-para {
  background: #f2f3f4;
  padding: 3px 8px;
  border-radius: 7px;
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 22px;
  color: #939393;
  display: inline-block;
}
body .reminder-history-box-single-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
body .reminder-history-box-single-info-show {
  font-size: 10.5px;
  line-height: 18px;
  color: #515151;
  font-weight: 400;
}
body .reminder-text-editor {
  height: 60px !important;
  min-height: 50px;
  border: 1px solid rgba(204, 204, 204, 0.2705882353);
  border-radius: 3px;
  display: flex;
}
body .reminder-text-editor:focus {
  border-color: #e7d896 !important;
  box-shadow: 0 0 0 0.25rem rgba(231, 216, 150, 0.4);
  outline: none;
}
body .reminder-text-editor-box {
  width: 100%;
  height: 100%;
  padding: 5px;
  border: none;
  outline: none;
  font-size: 15px;
  color: #474747;
}
body .reminder-text-editor-submit-btn {
  height: 30px;
  margin: auto 5px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
  border-radius: 4px;
}
body .reminder-head {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
}
body .reminder-head p {
  font-size: 17px;
}
@media (max-width: 767px) {
  body .reminder-head p {
    font-size: 17px;
  }
}
@media (max-width: 500px) {
  body .reminder-head p {
    font-size: 16px;
  }
}
@media (max-width: 767px) {
  body .reminder-head {
    gap: 8px;
  }
}
body .customer-reminder {
  height: 200px;
  min-height: 100px;
}
body .customer-reminder-table {
  border-collapse: collapse;
  width: 100%;
  border-spacing: 0;
}
body .customer-reminder-table thead {
  position: sticky;
  top: 0;
}
body .customer-reminder-table th {
  padding: 8px;
  text-align: left;
  border: none;
  font-size: 13px !important;
  font-weight: 500;
  text-transform: uppercase;
  color: #0f1114;
  white-space: nowrap;
}
@media (max-width: 500px) {
  body .customer-reminder-table th {
    font-size: 12px !important;
    font-weight: 500;
  }
}
body .customer-reminder-table td {
  padding: 8px;
  text-align: left;
  border: none;
  white-space: nowrap;
  padding: 6px 6px;
  font-size: 12px;
  white-space: nowrap;
}
body .setting-main-box-header {
  padding-left: 20px;
}
body .setting-main-box-header .nav-pills .nav-link.active, body .setting-main-box-header .nav-pills .show > .nav-link {
  color: #000;
  background-color: #e7d993;
  border: none;
  border-bottom: 2px solid #e7d993;
}
body .setting-main-box-header-toggle-btn {
  padding: 6px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 0 !important;
  border: none;
  background-color: #fff;
  color: #000;
  margin: 0;
  border-bottom: 2px solid #e7d993;
  text-decoration: none;
  width: 120px;
  text-align: center;
}
body .setting-main-box-header-toggle-btn:focus, body .setting-main-box-header-toggle-btn:hover {
  color: #000;
}
@media (max-width: 450px) {
  body .setting-main-box-header-toggle-btn {
    width: 90px;
    min-width: 70px;
  }
}
body .setting-main-box-body-card-box-subBody {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding-left: 15px;
}
body .setting-main-box-body-card-box-subBody .setting-form-label {
  font-size: 14px;
  color: #5b5959;
  font-weight: 500;
  white-space: nowrap;
}
@media (max-width: 767px) {
  body .setting-main-box-body-card-box-subBody .setting-form-label {
    font-size: 12px;
    text-align: start;
    width: 100%;
  }
}
@media (max-width: 767px) {
  body .setting-main-box-body-card-box-subBody {
    flex-direction: column;
    gap: 3px;
  }
}
body .setting-main-box-body-card-box-subBody .setting-key-update-btn {
  width: 100px;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 450px) {
  body .setting-main-box-body-card-box-subBody .setting-key-update-btn {
    margin-top: 15px;
    width: 100%;
  }
}
body .setting-form-imput-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: 100%;
}
@media (max-width: 767px) {
  body .setting-form-imput-box {
    flex-direction: column;
    margin-bottom: 10px;
    gap: 2px;
  }
}
body .pnl-com-show-field {
  padding: 6px 10px;
}
body .pnl-com-show-field-para {
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  margin: 0;
  padding-left: 10px;
  display: flex;
  justify-content: flex-end;
  width: 50%;
}
@media (max-width: 500px) {
  body .pnl-com-show-field-para {
    font-size: 14px;
    line-height: 18px;
    width: 50%;
    padding-left: 10px;
  }
}
@media (max-width: 400px) {
  body .pnl-com-show-field-para {
    width: 65%;
  }
}
body .pnl-com-show-field-amount {
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
  margin: 0;
  padding-left: 10px;
  width: 50%;
}
@media (max-width: 500px) {
  body .pnl-com-show-field-amount {
    font-size: 14px;
    line-height: 18px;
    width: 50%;
  }
}
@media (max-width: 400px) {
  body .pnl-com-show-field-amount {
    width: 35%;
  }
}
body .transfer-car-amount-box {
  width: 85%;
}
body .transfer-car-amount-box-para {
  width: 50%;
}
body .transfer-car-amount-box-show {
  width: 65%;
}
body .hour-car-amount-box {
  width: 85%;
}
body .hour-car-amount-box-para {
  width: 50%;
}
body .hour-car-amount-box-show {
  width: 65%;
}

.otp-com-input {
  width: 20%;
  padding: 5px 8px !important;
  text-align: center !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.paid-label {
  background: #0d790d;
  color: #Fff;
  text-align: center;
  width: 64px;
  border-radius: 10px;
  height: 21px;
  padding: 2px 10px;
}

.unpaid-label {
  background: #f14e4e;
  color: #Fff;
  text-align: center;
  width: 64px;
  border-radius: 10px;
  height: 21px;
  padding: 2px 10px;
}

.pending-label {
  background: #f9c242;
  color: #Fff;
  text-align: center;
  width: 64px;
  border-radius: 10px;
  height: 21px;
  padding: 2px 10px;
}

.ready-label {
  background: #4259f9;
  color: #Fff;
  text-align: center;
  width: 64px;
  border-radius: 10px;
  height: 21px;
  padding: 2px 10px;
}

.pickup-label {
  background: #42f95e;
  color: #Fff;
  text-align: center;
  width: 64px;
  border-radius: 10px;
  height: 21px;
  padding: 2px 10px;
}

.notaccept-label {
  background: #f1794e;
  color: #Fff;
  text-align: center;
  width: 64px;
  border-radius: 10px;
  height: 21px;
  padding: 2px 10px;
}

.aftertime-label {
  background: #8522ef;
  color: #Fff;
  text-align: center;
  width: 64px;
  border-radius: 10px;
  height: 21px;
  padding: 2px 10px;
}

.refunded-label {
  background: #4ee3f1;
  color: #Fff;
  text-align: center;
  width: 64px;
  border-radius: 10px;
  height: 21px;
  padding: 2px 10px;
}

.accept-label {
  background: #f942d1;
  color: #Fff;
  text-align: center;
  width: 64px;
  border-radius: 10px;
  height: 21px;
  padding: 2px 10px;
}

.main-header-right-user-img {
  width: 33px;
  height: 33px;
  min-width: 33px;
}
.main-header-right-user-img > img {
  width: 100%;
  height: 100%;
  border-radius: 50px;
  object-fit: cover;
}

.rolebackground {
  color: #03a9f4 !important;
}

.orderbackground {
  color: #ff9800 !important;
}

.staffbackground {
  color: #3f51b5 !important;
}

.assignbackground {
  color: #34af39 !important;
}

.loader {
  z-index: 999;
  height: 100vh;
  width: 100vw;
  background-color: rgb(26, 37, 69);
}
.loader img {
  width: 100px;
  z-index: 1;
  animation: loaderLogo 2s infinite linear;
}
@keyframes loaderLogo {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #a6aab5;
  border-radius: 20px;
}

.main-sidebar-menu-dropdown a {
  text-decoration: none;
}

.text-black {
  color: #000;
}

.lettercapital {
  text-transform: capitalize;
}

.surge-car-amount-box-show, .meet-car-amount-box-show {
  justify-content: space-between;
  margin-bottom: 15px;
}

.border-danger__control {
  border: "1px solid red";
}

#Trackdrivermodal .modal-content {
  width: 750px;
}

.trackdriver-btn {
  background-color: #0025ff !important;
}

.copylinkbtn {
  background-color: #9c00cc !important;
}

.addcalendarbtn {
  background-color: #007acc !important;
}

.editcustomerdetailsbtn {
  background-color: #7c5aff !important;
}

div.pac-container.pac-logo {
  z-index: 9999 !important;
}

.orderdate-div {
  height: 36px;
  border-radius: 13px;
  background: #ffffff;
}

.orderdate-div .dateranger {
  height: 35px !important;
}

.custom-full-width-date-time-picker .react-datepicker-wrapper {
  width: 100%;
}

.custom-full-width-date-time-picker .react-datepicker-wrapper .react-datepicker__input-container input {
  width: 100%;
  border: 1px solid rgba(204, 204, 204, 0.2705882353);
  padding: 8px;
}

.rc-time-picker-clear {
  display: none;
}

.rc-time-picker-input {
  width: 100%;
  height: 40px;
  padding: 8px;
}

.manualpaymentbtn {
  background-color: #ff9595 !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.scss","webpack://./src/assets/css/variables.scss"],"names":[],"mappings":"AAEA;EACE,oCAAA;EACA,cCDY;ADAd;AAEE;EACE,aAAA;AAAJ;AACI;EACE,WAAA;EACA,iBAAA;EACA,uBAAA;AACN;AACI;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AACN;AACI;EACE,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AACN;AAAM;EACE,YAAA;AAER;AAAM;EACE,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,iCAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AAER;AAAM;EACE,yBAAA;EACA,eAAA;AAER;AAEE;EACE,mDAAA;EACA,kBAAA;EACA,WAAA;EAEA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AADJ;AAGE;EACE,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AADJ;AAIE;EACE,UAAA;EACA,2BAAA;EACA,6BAAA;AAFJ;AAIE;;EAEC,wBAAA;AAFH;AAKE;EAEE,aAAA;EACA,uBAAA;EACA,kBAAA;AAJJ;AAKI;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,iBAAA;AAHN;AAIM;EALF;IAMI,qBAAA;EADN;AACF;AAGI;EACE,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;AADN;AAEM;EANF;IAOI,mBAAA;EACN;AACF;AAAM;EACE,mDAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAER;AAAM;EACE,iBAAA;EACA,gDAAA;EACA,4BAAA;AAER;AADQ;EAJF;IAKI,iBAAA;EAIR;AACF;AAHQ;EAPF;IAQI,4BAAA;IACA,gBAAA;IACA,aAAA;EAMR;AACF;AALQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,4BAAA;AAOV;AANU;EARF;IASI,4BAAA;EASV;AACF;AAPQ;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AASV;AAPQ;EACE,YAAA;AASV;AARU;EAFF;IAGI,WAAA;EAWV;AACF;AARM;EACE,kBAAA;EACA,4BAAA;EACA,2CAAA;AAUR;AATQ;EAJF;IAKI,4BAAA;IACA,kBAAA;EAYR;AACF;AAXQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,WAAA;EACA,4BAAA;AAaV;AAZU;EARF;IASI,4BAAA;EAeV;AACF;AAbQ;EACE,YAAA;EACA,aAAA;EACA,wGAAA;AAeV;AAdU;EAJF;IAKI,UAAA;IACA,aAAA;EAiBV;AACF;AAdU;EACE,cCrKD;EDsKC,gBAAA;EACA,eAAA;AAgBZ;AAdU;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAgBZ;AAfY;EACE,yBAAA;EACA,mDAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAiBd;AAhBc;EANF;IAOI,eAAA;EAmBd;AACF;AAlBc;EACE,gCAAA;EACA,kDAAA;EACA,aAAA;AAoBhB;AAjBY;EACE,kBAAA;EACA,UAAA;AAmBd;AAlBc;EAHF;IAII,UAAA;EAqBd;AACF;AAnBY;EACE,WAAA;AAqBd;AAlBU;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAoBZ;AAlBU;EACE,eAAA;EACA,cC/MD;ADmOX;AAZI;EACE,aAAA;AAcN;AAXM;EACE,WAAA;EACA,yBAAA;AAaR;AAZQ;EAHF;IAII,0BAAA;EAeR;AACF;AAZI;EACE,eAAA;EACA,6BAAA;AAcN;AAbM;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AAeR;AAXI;EACE,yBCtPU;ADmQhB;AAXI;EACE,cCzPU;ADsQhB;AAXI;EACE,YAAA;AAaN;AAXI;EACE,yBC5PO;ADyQb;AAXI;EACE,cC/PO;AD4Qb;AAXI;EACE,gBAAA;EACA,mEAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBCvQS;ADoRf;AAZM;EANF;IAOI,aAAA;EAeN;AACF;AAXE;EACE,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AAaJ;AAZI;EANF;IAOI,0BAAA;EAeJ;AACF;AAZE;;EAEE,wBAAA;AAcJ;AAZE;EACE,2CAAA;EACA,eAAA;EACA,cClSY;ADgThB;AAXE;EACE,aAAA;AAaJ;AAXE;EACE,mDAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAaJ;AAZI;EACE,gCAAA;EACA,kDAAA;EACA,aAAA;AAcN;AAVI;EAEE,eAAA;AAWN;AAVM;EAHF;IAII,WAAA;EAaN;AACF;AAVE;EACE,eAAA;AAYJ;AAVI;EACE,8DAAA;EACA,eAAA;AAYN;AAXM;EAHF;IAII,YAAA;EAcN;AACF;AAbM;EACE,gCAAA;EACA,kDAAA;EACA,aAAA;AAeR;AAbM;EACE,gBAAA;AAeR;AAZI;EACE,aAAA;AAcN;AAZI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAcN;AAbM;EAJF;IAKI,eAAA;EAgBN;AACF;AAdI;EACE,UAAA;AAgBN;AAdI;EACE,eAAA;EACA,eAAA;AAgBN;AAfM;EACE,oCAAA;EACA,cCnWM;ADoXd;AAfM;EACE,yBCjWE;ADkXV;AAbE;EACE,kBAAA;EACA,iBAAA;EACA,YC1WW;ED2WX,cAAA;AAeJ;AAdI;EACE,iBAAA;EACA,yBAAA;AAgBN;AAdI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAgBN;AAbE;EACE,kBAAA;AAeJ;AAdI;EACE,WAAA;EACA,2CAAA;EACA,0BAAA;AAgBN;AAfM;EACE,qBAAA;EACA,+BAAA;AAiBR;AAdI;EACE,yBAAA;EACA,kBAAA;EACA,qBAAA;AAgBN;AAdI;;EAEE,yBCrZU;EDsZV,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAgBN;AAfM;;EACE,aAAA;AAkBR;AAfI;;EAEE,aAAA;AAiBN;AAfI;EACE,mBAAA;AAiBN;AAfI;EACE,yBAAA;AAiBN;AAfI;EACE,qBC5aU;AD6bhB;AAdM;EACE,qBAAA;AAgBR;AAfQ;EACE,YAAA;EACA,cAAA;EACA,iBAAA;AAiBV;AAdM;EACE,mBAAA;EACA,gBAAA;AAgBR;AAdM;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AAgBR;AAfQ;EAJF;IAKI,eAAA;EAkBR;AACF;AAjBQ;EACE,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;AAmBV;AAfI;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBC/cU;EDgdV,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;AAiBN;AAdE;EACE,yBCjdM;ADieV;AAdE;EACE,eAAA;AAgBJ;AAdE;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;AAgBJ;AAfI;EACE,yBAAA;AAiBN;AAdE;EACE,yBAAA;AAgBJ;AAbI;EAEE,eAAA;AAcN;AAbM;EACE,0DAAA;EACA,qBC7eQ;AD4fhB;AAZI;EACE,eAAA;AAcN;AAZI;EACE,eAAA;EACA,kBAAA;AAcN;AAbM;EACE,gCAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,6BAAA;AAeR;AAdQ;EACE,yBC/fM;EDggBN,qBChgBM;ADghBhB;AAXE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAaJ;AAXE;EACE,eAAA;AAaJ;AAXE;EACE,eAAA;AAaJ;AAZI;EAFF;IAGI,eAAA;EAeJ;AACF;AAbE;EACE,eAAA;AAeJ;AAbE;EACE,eAAA;AAeJ;AAXI;EACE,YAAA;EACA,UAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;AAaN;AAZM;EACE,WChiBO;EDiiBP,gBAAA;AAcR;AAZQ;EAJF;IAKI,eAAA;EAeR;AACF;AAZI;EACE,eAAA;EACA,YAAA;EACA,uBAAA;EACA,+CAAA;EACA,kBAAA;EACA,oBAAA;AAcN;AAbM;EAPF;IAQI,YAAA;IACA,wBAAA;EAgBN;AACF;AAdI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAgBN;AAfM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,wCAAA;AAiBR;AAfM;EACE;IACE,UAAA;IACA,WAAA;IACA,UAAA;EAiBR;EAdM;IACE,WAAA;IACA,YAAA;IACA,UAAA;EAgBR;EAbM;IACE,WAAA;IACA,YAAA;IACA,UAAA;EAeR;AACF;AAbM;EACE,kBAAA;EACA,qBAAA;EACA,WCnmBO;EDomBP,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;AAeR;AAZI;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,gCAAA;AAcN;AAbM;EANF;IAOI,eAAA;EAgBN;AACF;AAdI;EACE,gBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAgBN;AAfM;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAiBR;AAhBQ;EACE,gBAAA;AAkBV;AAhBQ;EACE,qBAAA;EACA,WAAA;AAkBV;AAhBQ;EACE,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,gBAAA;AAkBV;AAjBU;EARF;IASI,eAAA;EAoBV;AACF;AAlBQ;EACE,sBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;AAoBV;AAnBU;EALF;IAMI,eAAA;EAsBV;AACF;AArBU;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;AAuBZ;AAtBY;EACE,iBAAA;AAwBd;AAjBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;AAmBN;AAjBM;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAmBR;AAhBM;EACE,eAAA;AAkBR;AAdE;EACE,YAAA;EAOA,kBAAA;EACA,gBAAA;EACA,cAAA;AAUJ;AAlBI;EAFF;IAGI,YAAA;EAqBJ;AACF;AApBI;EALF;IAMI,YAAA;EAuBJ;AACF;AAnBI;EACE,2BAAA;EACA,gBAAA;EACA,UAAA;AAqBN;AAnBI;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;AAqBN;AAnBI;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AAqBN;AApBM;EACE,gBAAA;EACA,eAAA;AAsBR;AArBQ;EAHF;IAII,eAAA;EAwBR;AACF;AAtBM;EACE,kBAAA;EACA,UAAA;AAwBR;AAvBQ;EACE,WAAA;EACA,YAAA;AAyBV;AAvBQ;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAyBV;AArBQ;EACE,eAAA;EACA,cAAA;AAuBV;AAtBU;EAHF;IAII,eAAA;EAyBV;AACF;AArBI;EACE,mBAAA;EACA,cAAA;AAuBN;AAtBM;EAHF;IAII,eAAA;IACA,kBAAA;EAyBN;AACF;AAvBI;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,OAAA;AAyBN;AAxBM;EARF;IASI,WAAA;EA2BN;AACF;AA1BM;EACE,yBAAA;EACA,YAAA;EACA,mBAAA;AA4BR;AAvBI;EADF;IAEI,UAAA;EA0BJ;AACF;AAxBE;EACE,mBAAA;AA0BJ;AAzBI;EAFF;IAGI,eAAA;IACA,gBAAA;EA4BJ;AACF;AAxBI;EAFF;IAGI,gBAAA;IACA,eAAA;EA2BJ;AACF;AA1BI;EANF;IAOI,gBAAA;EA6BJ;AACF;AA1BI;EACE,WAAA;AA4BN;AA3BM;EACE,sBAAA;AA6BR;AAxBI;EACE,WAAA;AA0BN;AAxBI;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AA0BN;AAvBE;EACE,aAAA;EACA,sBAAA;AAyBJ;AAvBE;EACE,WAAA;EACA,YAAA;EACA,aCvzBQ;ADg1BZ;AAvBE;EACE,oCAAA;EACA,WAAA;AAyBJ;AAvBE;EACE,oCAAA;EACA,sBAAA;AAyBJ;AAvBE;EACE,oCAAA;EACA,sBAAA;AAyBJ;AAvBE;EACE,oCAAA;EACA,sBAAA;AAyBJ;AAvBE;EACE,sBAAA;EACA,oCAAA;AAyBJ;AArBE;EACE,sBAAA;AAuBJ;AArBE;EACE,yBAAA;AAuBJ;AApBI;EACE,YAAA;EACA,cAAA;EACA,cAAA;AAsBN;AApBI;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AAsBN;AAnBE;EACE,8BAAA;EACA,mBAAA;AAqBJ;AApBI;EAHF;IAII,sBAAA;IACA,SAAA;EAuBJ;AACF;AArBE;EACE,kBAAA;EACA,eAAA;AAuBJ;AArBE;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAuBJ;AArBE;EAEE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAsBJ;AApBE;EACE,cAAA;AAsBJ;AApBE;EACE,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;AAsBJ;AArBI;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAuBN;AAtBM;EACE,aAAA;AAwBR;AAnBE;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;AAqBJ;AAnBE;EACE,oCAAA;AAqBJ;AAnBE;EACE,yBAAA;AAqBJ;AAnBE;EACE,sDAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAqBJ;AApBI;EACE,eAAA;AAsBN;AAnBM;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAqBR;AApBQ;EALF;IAMI,eAAA;EAuBR;AACF;AAtBQ;EARF;IASI,YAAA;EAyBR;AACF;AArBM;EADF;IAEI,YAAA;EAwBN;AACF;AAvBM;EACE,yBAAA;EACA,mBAAA;AAyBR;AAvBM;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AAyBR;AAfE;;;;EAIE,mBAAA;AAiBJ;AAfE;;;EAGE,WAAA;EAEA,eAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AAgBJ;AAdE;;;EAGE,eAAA;AAgBJ;AAbE;EACE,aAAA;EACA,QAAA;EACA,yBAAA;EACA,mBAAA;AAeJ;AAdI;EALF;IAMI,eAAA;EAiBJ;AACF;AAfE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA,EAKG,6CAAA;EACH,aAAA;EACA,uBAAA;EACA,mBAAA;AAYJ;AAVE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,UAAA;AAYJ;AAXI;EANF;IAOI,eAAA;IACA,SAAA;EAcJ;AACF;AAZE;EACE,UAAA;AAcJ;AAbI;EAFF;IAGI,UAAA;EAgBJ;AACF;AAfI;EALF;IAMI,UAAA;EAkBJ;AACF;AAjBI;EARF;IASI,UAAA;EAoBJ;AACF;AAlBE;EACE,YAAA;AAoBJ;AAnBI;EAFF;IAGI,UAAA;EAsBJ;AACF;AArBI;EALF;IAMI,UAAA;EAwBJ;AACF;AAvBI;EARF;IASI,UAAA;EA0BJ;AACF;AAxBE;EAEE,aAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAyBJ;AAxBI;EACE,mBAAA;AA0BN;AAzBM;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;AA2BR;AAzBM;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;AA2BR;AA1BQ;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AA4BV;AAvBE;EACE,uBAAA;EACA,gBAAA;EACA,mDAAA;EACA,kBAAA;EACA,aAAA;AAyBJ;AAxBI;EACE,gCAAA;EACA,kDAAA;EACA,aAAA;AA0BN;AAxBI;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;AA0BN;AAxBI;EACE,YAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AA0BN;AAvBE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;AAyBJ;AAxBI;EACE,eAAA;AA0BN;AAzBM;EAFF;IAGI,eAAA;EA4BN;AACF;AA3BM;EALF;IAMI,eAAA;EA8BN;AACF;AA5BI;EAdF;IAeI,QAAA;EA+BJ;AACF;AA7BE;EACE,aAAA;EACA,iBAAA;AA+BJ;AA9BI;EACE,yBAAA;EACA,WAAA;EACA,iBAAA;AAgCN;AA/BM;EACE,gBAAA;EACA,MAAA;AAiCR;AA/BM;EACE,YAAA;EACA,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AAiCR;AAhCQ;EATF;IAUI,0BAAA;IACA,gBAAA;EAmCR;AACF;AAjCM;EACE,YAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAmCR;AA9BI;EACE,kBAAA;AAgCN;AA/BM;EACE,WAAA;EACA,yBAAA;EACA,YAAA;EACA,gCAAA;AAiCR;AA/BM;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;EACA,gCAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;AAiCR;AAhCQ;EACE,WAAA;AAkCV;AAhCQ;EAhBF;IAiBI,WAAA;IACA,eAAA;EAmCR;AACF;AA1BQ;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AA4BV;AA3BU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AA6BZ;AA5BY;EALF;IAMM,eAAA;IACA,iBAAA;IACA,WAAA;EA+Bd;AACF;AA7BU;EAjBF;IAkBI,sBAAA;IACA,QAAA;EAgCV;AACF;AA/BU;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAiCZ;AAhCY;EANF;IAOI,gBAAA;IACA,WAAA;EAmCZ;AACF;AA5BE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AA8BJ;AA7BI;EANF;IAOI,sBAAA;IACA,mBAAA;IACA,QAAA;EAgCJ;AACF;AA9BE;EACE,iBAAA;AAgCJ;AA/BI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,UAAA;AAiCN;AAhCM;EATF;IAUI,eAAA;IACA,iBAAA;IACA,UAAA;IACA,kBAAA;EAmCN;AACF;AAlCM;EAfF;IAgBI,UAAA;EAqCN;AACF;AAnCI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AAqCN;AApCM;EAPF;IAQI,eAAA;IACA,iBAAA;IACA,UAAA;EAuCN;AACF;AAtCM;EAZF;IAaI,UAAA;EAyCN;AACF;AAtCE;EACE,UAAA;AAwCJ;AAvCI;EACE,UAAA;AAyCN;AAvCI;EACE,UAAA;AAyCN;AAtCE;EACE,UAAA;AAwCJ;AAvCI;EACE,UAAA;AAyCN;AAvCI;EACE,UAAA;AAyCN;;AApCA;EACE,UAAA;EACA,2BAAA;EACA,6BAAA;AAuCF;;AArCA;;EAEG,wBAAA;AAwCH;;AAtCA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAyCF;;AAvCA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AA0CF;;AAxCA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AA2CF;;AAzCA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AA4CF;;AA1CA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AA6CF;;AA3CA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AA8CF;;AA5CA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AA+CF;;AA7CA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAgDF;;AA9CA;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AAiDF;;AA/CA;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAkDF;AAjDE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;AAmDJ;;AAhDC;EACC,yBAAA;AAmDF;;AAjDC;EACC,yBAAA;AAoDF;;AAlDC;EACC,yBAAA;AAqDF;;AAnDC;EACC,yBAAA;AAsDF;;AApDA;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,iCAAA;AAuDF;AAtDE;EACE,YAAA;EACA,UAAA;EACA,wCAAA;AAwDJ;AAvDI;EACE;IACE,wBAAA;EAyDN;EAvDI;IACE,0BAAA;EAyDN;AACF;;AApDA;EACE,UAAA;EACA,WAAA;AAuDF;;AArDA;EACE,6BAAA;AAwDF;;AAtDA;EACE,yBAAA;EACA,mBAAA;AAyDF;;AAvDA;EACE,qBAAA;AA0DF;;AAxDA;EACE,WAAA;AA2DF;;AAzDA;EACE,0BAAA;AA4DF;;AA1DA;EACE,8BAAA;EACA,mBAAA;AA6DF;;AA3DA;EACG,uBAAA;AA8DH;;AA5DA;EACE,YAAA;AA+DF;;AA7DA;EACE,oCAAA;AAgEF;;AA9DA;EACE,oCAAA;AAiEF;;AA9DA;EACE,oCAAA;AAiEF;;AA/DA;EACE,oCAAA;AAkEF;;AA/DA;EACE,wBAAA;AAkEF;;AAhEA;EACE,YAAA;EACE,mBAAA;EACA,mBAAA;AAmEJ;;AAjEA;EACE,uBAAA;AAoEF;;AAlEA;EACE,WAAA;AAqEF;;AAlEA;EACE,WAAA;EACF,mDAAA;EACE,YAAA;AAqEF;;AAlEA;EACE,aAAA;AAqEF;;AAnEA;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAsEF;;AApEA;EACE,oCAAA;AAuEF","sourcesContent":["@import \"./variables.scss\";\n\nbody {\n  font-family: \"Open Sans\", sans-serif;\n  color: $dark-color;\n  .com-page {\n    height: 100vh;\n    &-cover {\n      z-index: -1;\n      object-fit: cover;\n      object-position: bottom;\n    }\n    &-top-sec-logo {\n      position: absolute;\n      top: 1.3580246913580247vw;\n      width: 9.62vw;\n      transform: none;\n      left: 20px;\n      z-index: 1;\n    }\n    .form-box {\n      width: 560px;\n      border-radius: 10px;\n      background-color: rgb(255 255 255 / 91%);\n      border: 6px solid $golden-color;\n      padding: 50px 60px;\n      max-width: 90%;\n      &-logo {\n        width: 100px;\n      }\n      &-btn {\n        font-size: 20px;\n        background-color: #21fdc2 !important;\n        border-radius: 50px;\n        border: 2px solid $white-color !important;\n        color: $dark-color !important;\n        min-height: 50px;\n        font-weight: 500;\n      }\n      &-small-text {\n        color: #0f2a75 !important;\n        font-size: 12px;\n      }\n    }\n  }\n  .multi-email-label-box {\n    border: 1px solid rgba(204, 204, 204, 0.2705882353);\n    border-radius: 3px;\n    width: 100%;\n    // height: 40px;\n    padding: 4px 8px;\n    display: flex;\n    flex-wrap: wrap;\n    max-height: 120px;\n    overflow-y: auto;\n    font-size: 14px;\n  }\n  .single-email-label {\n    border: none;\n    padding: 3px 6px;\n    background: #e8da99;\n    font-size: 14px;\n    font-weight: 400;\n    border-radius: 4px;\n    margin: 3px 5px 3px 0;\n  }\n\n  .otp-com-input {\n    width: 20%;\n    padding: 5px 8px !important;\n    text-align: center !important;\n  }\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n   -webkit-appearance: none;\n  }\n\n  .form-design {\n\n    height: 100vh;\n    justify-content: center;\n    position: relative;\n    &-bg {\n      position: absolute;\n      left: 0;\n      top: 0;\n      object-fit: cover;\n      @media (max-width: 767px) {\n        object-position: left;\n      }\n    }\n    &-inner {\n      border-radius: 20px;\n      width: 90%;\n      max-width: 780px;\n      z-index: 1;\n      border: 1px solid $golden-color;\n      @media (max-width: 767px) {\n        border-radius: 15px;\n      }\n      .dot {\n        background-color: #f6efcf94;\n        width: 60px;\n        height: 60px;\n        z-index: -1;\n      }\n      &-left {\n        min-height: 400px;\n        background-color: #12265fb0;\n        border-radius: 20px 0 0 20px;\n        @media (max-width: 1000px) {\n          min-height: 370px;\n        }\n        @media (max-width: 767px) {\n          border-radius: 15px 15px 0 0;\n          min-height: auto;\n          padding: 20px;\n        }\n        &:after {\n          content: \"\";\n          width: 100%;\n          height: 100%;\n          position: absolute;\n          backdrop-filter: blur(10px);\n          z-index: -1;\n          border-radius: 20px 0 0 20px;\n          @media (max-width: 767px) {\n            border-radius: 15px 15px 0 0;\n          }\n        }\n        .dot {\n          left: -15px;\n          top: -26px;\n          width: 50px;\n          height: 50px;\n        }\n        img {\n          width: 110px;\n          @media (max-width: 767px) {\n            width: 90px;\n          }\n        }\n      }\n      &-right {\n        padding: 20px 50px;\n        border-radius: 0 20px 20px 0;\n        background-color: rgb(245 238 202 / 39%);\n        @media (max-width: 767px) {\n          border-radius: 0 0 15px 15px;\n          padding: 25px 30px;\n        }\n        &:after {\n          content: \"\";\n          width: 100%;\n          height: 100%;\n          position: absolute;\n          backdrop-filter: blur(10px);\n          z-index: -1;\n          border-radius: 0 20px 20px 0;\n          @media (max-width: 767px) {\n            border-radius: 0 0 15px 15px;\n          }\n        }\n        .dot {\n          right: -25px;\n          bottom: -25px;\n          background: linear-gradient(45deg, #97927421, #e7d99326);\n          @media (max-width: 767px) {\n            right: 0px;\n            bottom: -25px;\n          }\n        }\n        &-inner {\n          &-heading {\n            color: $mainBlue;\n            font-weight: 700;\n            font-size: 26px;\n          }\n          &-input {\n            display: flex;\n            align-items: center;\n            position: relative;\n            input {\n              background-color: #dee6ff;\n              border: 1px solid rgba(204, 204, 204, 0.2705882353);\n              border-radius: 5px;\n              height: 35px;\n              padding: 0 43px;\n              @media (max-width: 767px) {\n                padding: 0 34px;\n              }\n              &:focus {\n                border-color: #e7d896 !important;\n                box-shadow: 0 0 0 0.25rem rgb(231 216 150 / 40%);\n                outline: none;\n              }\n            }\n            &-left-icon {\n              position: absolute;\n              left: 15px;\n              @media (max-width: 767px) {\n                left: 10px;\n              }\n            }\n            &-password-icon {\n              right: 15px;\n            }\n          }\n          &-btn {\n            min-width: 100px;\n            font-size: 14px;\n            font-weight: 600;\n            border-radius: 2px;\n          }\n          &-link {\n            font-size: 12px;\n            color: $mainBlue;\n          }\n        }\n      }\n    }\n  }\n\n  .main-page {\n    &-row {\n      display: flex;\n      &-left {\n      }\n      &-right {\n        width: 100%;\n        background-color: #f7f7f7;\n        @media (min-width: 1200px) {\n          width: calc(100vw - $sidebarWidth);\n        }\n      }\n    }\n    &-body {\n      padding: 0 20px;\n      min-height: calc(100% - 53px);\n      &-scroll {\n        height: 100vh;\n        overflow-y: auto;\n        background-color: #f7f7f7;\n        padding-top: calc($headerHeight + 20px);\n      }\n    }\n\n    .golden-bg {\n      background-color: $golden-color;\n    }\n    .golden-text {\n      color: $golden-color;\n    }\n    .resize-none {\n      resize: none;\n    }\n    .gray-bg {\n      background-color: $gray-color;\n    }\n    .main-gray {\n      color: $gray-color;\n    }\n    .com-card-box {\n      padding: 1.25rem;\n      box-shadow: transparent 0px 2px 4px, rgba(0, 0, 0, 0.1) 0px 2px 6px;\n      margin-bottom: 1.25rem;\n      border-radius: 0.25rem;\n      background: $white-color;\n      @media (max-width: 1200px) {\n        padding: 10px;\n      }\n    }\n  }\n\n  .com-heading {\n    font-size: 15px !important;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #0f1114;\n    margin-bottom: 18px;\n    @media (max-width: 767px) {\n      font-size: 11px !important;\n    }\n  }\n\n  .after-before-none:before,\n  .after-before-none:after {\n    content: none !important;\n  }\n  .golden-heading {\n    -webkit-text-stroke: 1px rgba(189, 166, 108, 1);\n    font-size: 40px;\n    color: $golden-color;\n  }\n\n  .scroll-none::-webkit-scrollbar {\n    display: none;\n  }\n  .com-input-field {\n    border: 1px solid #cccccc45;\n    border-radius: 3px;\n    display: block;\n    width: 100%;\n    height: 40px;\n    padding: 2px 12px;\n    font-size: 14px;\n    &:focus {\n      border-color: #e7d896 !important;\n      box-shadow: 0 0 0 0.25rem rgb(231 216 150 / 40%);\n      outline: none;\n    }\n  }\n  .com-modal .com-select {\n    &__control {\n      // border: 1px solid #cccccc45 !important;\n      min-width: 80px;\n      @media (max-width: 550px) {\n        width: 100%;\n      }\n    }\n  }\n  .com-select {\n    font-size: 14px;\n\n    &__control {\n      border: 1px solid #cccccc45 !important;\n      min-width: 80px;\n      @media (max-width: 550px) {\n        width:100px;\n      }\n      &--is-focused {\n        border-color: #e7d896 !important;\n        box-shadow: 0 0 0 0.25rem rgb(231 216 150 / 40%);\n        outline: none;\n      }\n      .css-1xc3v61-indicatorContainer {\n        padding: 4px 4px;\n      }\n    }\n    &__indicator-separator {\n      display: none;\n    }\n    &__value-container {\n      font-size: 14px;\n      padding-right: 0;\n      white-space: nowrap;\n      @media (max-width: 500px) {\n        font-size: 12px;\n      }\n    }\n    &__menu-list {\n      padding: 0;\n    }\n    &__option {\n      font-size: 14px;\n      cursor: pointer;\n      &--is-selected {\n        background-color: $golden-color !important;\n        color: $dark-color;\n      }\n      &--is-focused {\n        background-color: $hoverbg;\n      }\n    }\n  }\n  .profile-page-left-user {\n    position: relative;\n    aspect-ratio: 1/1;\n    width: $sidebarWidth;\n    max-width: 65%;\n    img {\n      object-fit: cover;\n      border: 1px solid #ededed;\n    }\n    &-edit-pencil {\n      position: absolute;\n      bottom: 0px;\n      right: 0px;\n      width: 18px;\n      height: 18px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border: 1px solid #938989;\n      border-radius: 50px;\n      padding: 2px;\n      cursor: pointer;\n    }\n  }\n  .com-datatable {\n    position: relative;\n    &-loader {\n      z-index: 99;\n      background-color: rgb(255 255 255 / 11%);\n      backdrop-filter: blur(2px);\n      .spinner-border {\n        border-color: #e8da99;\n        border-right-color: transparent;\n      }\n    }\n    .sc-cyZbyy {\n      border: 1px solid $golden-color;\n      border-radius: 5px;\n      padding: 0 30px 0 8px;\n    }\n    #pagination-previous-page,\n    #pagination-next-page {\n      background-color: $golden-color;\n      border-radius: 4px;\n      border: 1px solid #dde1ef;\n      height: 33px;\n      padding: 0;\n      width: 33px;\n      border: none;\n      margin-left: 10px;\n      path:first-child {\n        fill: #212529;\n      }\n    }\n    #pagination-first-page,\n    #pagination-last-page {\n      display: none;\n    }\n    .rdt_TableRow:not(:last-of-type) {\n      border-bottom: none;\n    }\n    .rdt_TableRow:nth-child(odd) {\n      background-color: #f6f8ff;\n    }\n    input[type=\"checkbox\"] {\n      accent-color: $golden-color;\n    }\n    .rdt {\n      &_TableCol_Sortable {\n        opacity: 1 !important;\n        span {\n          opacity: 0.8;\n          padding-top: 0;\n          padding-bottom: 0;\n        }\n      }\n      &_TableCol {\n        white-space: nowrap;\n        font-weight: 600;\n      }\n      &_TableCell {\n        white-space: nowrap;\n        padding: 6px 6px;\n        font-size: 13px;\n        @media (max-width: 1366px) {\n          font-size: 12px;\n        }\n        & > div {\n          white-space: pre-line;\n          overflow: visible;\n          text-align: start;\n          width: 100%;\n          line-height: 20px;\n        }\n      }\n    }\n    .cell-tabs {\n      width: fit-content;\n      border: none;\n      margin: 2px 5px;\n      background-color: $golden-color;\n      border-radius: 3px;\n      text-align: center;\n      padding: 1px 3px;\n      text-transform: capitalize;\n    }\n  }\n  .hover-bg:hover {\n    background-color: $hoverbg;\n  }\n  .cursor-pointer {\n    cursor: pointer;\n  }\n  .com-btn {\n    border-radius: 4px;\n    padding: 6px 10px;\n    color: #000;\n    &-outline {\n      border: 1px solid $golden-color;\n    }\n  }\n  .golden-border {\n    border: 1px solid $golden-color;\n  }\n  .form {\n    &-control,\n    &-select {\n      font-size: 13px;\n      &:focus {\n        box-shadow: 0 0 0 0.25rem lch(86.65 36.43 93.72 / 0.3);\n        border-color: $golden-color;\n      }\n    }\n    &-label {\n      font-size: 13px;\n    }\n    &-check {\n      font-size: 13px;\n      padding-left: 30px;\n      &-input {\n        border-color: $golden-color !important;\n        box-shadow: none !important;\n        width: 15px;\n        height: 15px;\n        border-radius: 2px !important;\n        margin-top: 2px;\n        margin-left: -24px !important;\n        &:checked {\n          background-color: $golden-color;\n          border-color: $golden-color;\n        }\n      }\n    }\n  }\n  .com-table-check-box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .font-15px {\n    font-size: 15px;\n  }\n  .font-13px {\n    font-size: 13px;\n    @media (min-width: 500px) {\n      font-size: 12px;\n    }\n  }\n  .font-12px {\n    font-size: 12px;\n  }\n  .font-11px {\n    font-size: 11px;\n  }\n\n  .notification-area {\n    &-btn {\n      border: none;\n      padding: 0;\n      background-color: transparent;\n      position: relative;\n      display: block;\n      i {\n        color: $white-color;\n        transition: 0.3s;\n\n        @media (min-width: 1599px) {\n          font-size: 18px;\n        }\n      }\n    }\n    .dropdown-menu {\n      padding: 10px 0;\n      width: 300px;\n      right: -65px !important;\n      box-shadow: 0 4px 8px rgb(147 147 147 / 24%);\n      border-radius: 3px;\n      top: 53px !important;\n      @media (max-width: 991px) {\n        width: 200px;\n        right: -100px !important;\n      }\n    }\n    &-count {\n      position: absolute;\n      top: 1px;\n      right: 4px;\n      min-width: 8px;\n      height: 8px;\n      border-radius: 10px;\n      font-size: 10px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      z-index: 1;\n      &:after {\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        border-radius: 50%;\n        background-color: #ffb9b9;\n        width: 40%;\n        height: 40%;\n        z-index: -1;\n        animation: circlewave 2s linear infinite;\n      }\n      @keyframes circlewave {\n        0% {\n          width: 40%;\n          height: 40%;\n          opacity: 1;\n        }\n\n        75% {\n          width: 135%;\n          height: 135%;\n          opacity: 1;\n        }\n\n        100% {\n          width: 160%;\n          height: 160%;\n          opacity: 0;\n        }\n      }\n      &-num {\n        position: relative;\n        background-color: red;\n        color: $white-color;\n        display: flex;\n        align-items: center;\n        width: 100%;\n        border-radius: 50%;\n        height: 100%;\n        justify-content: center;\n        padding: 0 3px;\n      }\n    }\n    &-heading {\n      margin-bottom: 8px;\n      font-size: 20px;\n      font-weight: 600;\n      padding: 0 0 9px 14px;\n      border-bottom: 1px solid #ededed;\n      @media (max-width: 767px) {\n        font-size: 15px;\n      }\n    }\n    &-list {\n      list-style: none;\n      padding: 0;\n      height: auto;\n      max-height: 230px;\n      overflow-y: auto;\n      &-single {\n        margin-bottom: 9px;\n        padding: 3px 18px;\n        cursor: pointer;\n        transition: 0.3s;\n        &:last-child {\n          margin-bottom: 0;\n        }\n        &-a {\n          text-decoration: none;\n          color: gray;\n        }\n        &-text {\n          font-size: 14px;\n          margin-bottom: 3px;\n          -webkit-line-clamp: 2;\n          -webkit-box-orient: vertical;\n          display: -webkit-box;\n          white-space: pre-wrap;\n          overflow: hidden;\n          @media (max-width: 767px) {\n            font-size: 11px;\n          }\n        }\n        &-foot {\n          color: rgb(92, 92, 92);\n          font-size: 12px;\n          display: flex;\n          justify-content: space-between;\n          @media (max-width: 767px) {\n            font-size: 10px;\n          }\n          &-user {\n            display: flex;\n            align-items: center;\n            text-transform: capitalize;\n            &-icon {\n              margin-right: 5px;\n            }\n          }\n        }\n      }\n    }\n\n    &-no-notification {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: rgb(92, 92, 92);\n      flex-direction: column;\n\n      i {\n        font-size: 50px;\n        color: #e7e7e7;\n        margin-bottom: 16px;\n      }\n\n      &-text {\n        font-size: 14px;\n      }\n    }\n  }\n  .analytics-box {\n    width: 308px;\n    @media (max-width: 900px) {\n      width: 270px;\n    }\n    @media (max-width: 650px) {\n      width: 230px;\n    }\n    position: relative;\n    transition: 0.3s;\n    flex-shrink: 0;\n    &:hover {\n      transform: translateY(-5px);\n      transition: 0.3s;\n      z-index: 1;\n    }\n    &-head {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n    }\n    &-body {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-end;\n      &-show {\n        font-weight: 700;\n        font-size: 22px;\n        @media (max-width: 1200px) {\n          font-size: 18px;\n        }\n      }\n      &-chart-box {\n        position: relative;\n        width: 50%;\n        &-canvas {\n          width: 100%;\n          height: 100%;\n        }\n        &-para {\n          margin: 3px 0;\n          text-align: center;\n          font-size: 0.675rem;\n          color: #0f1114;\n        }\n      }\n      &-first {\n        & p {\n          font-size: 14px;\n          color: #21a321;\n          @media (max-width: 1200px) {\n            font-size: 11px;\n          }\n        }\n      }\n    }\n    &-heading {\n      font-size: 0.875rem;\n      color: #0f1114;\n      @media (max-width: 1200px) {\n        font-size: 12px;\n        margin-bottom: 9px;\n      }\n    }\n    &-meter-box {\n      height: 5px;\n      background-color: #fbf6f6;\n      border-radius: 8px;\n      position: absolute;\n      width: 100%;\n      bottom: 0;\n      left: 0;\n      @media (max-width: 1200px) {\n        height: 2px;\n      }\n      &-inner {\n        background-color: #07a707;\n        height: 100%;\n        border-radius: 10px;\n      }\n    }\n  }\n  .order-card-box {\n    @media (max-width: 767px) {\n      width: 50%;\n    }\n  }\n  .golden-btn-respn-show {\n    white-space: nowrap;\n    @media (max-width: 567px) {\n      font-size: 11px;\n      padding: 6px 8px;\n    }\n  }\n  .res-all-golden-btn {\n\n    @media (max-width: 768px) {\n      margin-top: 10px;\n      flex-wrap: wrap;\n    }\n    @media (max-width: 567px) {\n      margin-top: 15px;\n    }\n  }\n  .balance-overview {\n    &-chart-box {\n      width: 100%;\n      &-canvas {\n        width: 100% !important;\n      }\n    }\n  }\n  .activity-chart-container {\n    &-box {\n      width: 100%;\n    }\n    &-para {\n      margin-top: -20px;\n      text-align: center;\n      font-size: 0.675rem;\n      color: #0f1114;\n    }\n  }\n  .orders-container-chart-box {\n    height: 300px;\n    width: 100% !important;\n  }\n  .exclama-deleteIcon {\n    width: 42px;\n    height: 42px;\n    fill: $dangerRed;\n  }\n  .danger-bg {\n    background-color: $dangerRed !important;\n    color: #fff;\n  }\n  .orange-bg {\n    background-color: $orange !important;\n    color: #fff !important;\n  }\n  .assign-bg {\n    background-color: #d52662 !important;\n    color: #fff !important;\n  }\n  .refund-bg {\n    background-color: #673ab7 !important;\n    color: #fff !important;\n  }\n  .customercall-bg{\n    color: #fff !important;\n    background-color:#3f73a2 !important;\n\n  }\n \n  .text-white {\n    color: #fff !important;\n  }\n  .danger-color {\n    color: #ff6961 !important;\n  }\n  .delete-item-modal {\n    &-dialog {\n      width: 350px;\n      margin: 0 auto;\n      max-width: 90%;\n    }\n    &-footer-btn {\n      border-radius: 20px;\n      padding: 5px 15px;\n      border: 1px solid $dangerRed;\n    }\n  }\n  .row-box-respnon-show {\n    justify-content: space-between;\n    align-items: center;\n    @media (max-width: 767px) {\n      flex-direction: column;\n      gap: 10px;\n    }\n  }\n  .tooltip-area {\n    position: relative;\n    cursor: pointer;\n  }\n  .tooltip-text {\n    display: none;\n    font-size: 11px;\n    background-color: #e7d896;\n    border-radius: 5px;\n    border: 1px solid #8b792c;\n    position: absolute;\n    left: 0%;\n    top: -20px;\n    z-index: 9999;\n    width: 100%;\n    height: auto;\n    text-align: center;\n    line-height: 15px;\n  }\n  .location-td {\n    // min-width: 180px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    text-align: left;\n  }\n  .tooltip-area:hover .tooltip-text {\n    display: block;\n  }\n  .completeIcon-box {\n    width: 42px !important;\n    height: 42px !important;\n    min-width: 42px;\n    display: inline-block;\n    svg {\n      fill: #099500;\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n      g {\n        fill: #099500;\n      }\n    }\n  }\n\n  .booking-complete-footer {\n    border-radius: 20px;\n    padding: 5px 15px;\n    border: 1px solid #099500;\n    color: #fff;\n  }\n  .bg-green {\n    background-color: #099500 !important;\n  }\n  .green-color {\n    color: #099500 !important;\n  }\n  .dateranger {\n    border: 1px solid rgba(139, 137, 137, 0.27) !important;\n    padding: 6px 8px;\n    border-radius: 7px;\n    color: #656161;\n    font-size: 13px;\n    height: 38px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    &-icon {\n      font-size: 15px;\n    }\n    .react-datepicker__input-container {\n      & > input {\n        border: none;\n        width: 155px;\n        margin-top: 5px;\n        outline: none;\n        @media (max-width: 767px) {\n          font-size: 12px;\n        }\n        @media (max-width: 500px) {\n          width: 155px;\n        }\n      }\n    }\n    .react-datepicker {\n      @media (max-width: 400px) {\n        width: 180px;\n      }\n      .react-datepicker__header {\n        background-color: #ffffff;\n        border-bottom: none;\n      }\n      .react-datepicker__navigation-icon::before {\n        border-color: #000;\n        right: -2px;\n        width: 7px;\n        height: 7px;\n      }\n      .react-datepicker__month-container {\n        .react-datepicker__month {\n          .react-datepicker__month {\n          }\n        }\n      }\n    }\n  }\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__month-text--keyboard-selected,\n  .react-datepicker__quarter-text--keyboard-selected,\n  .react-datepicker__year-text--keyboard-selected {\n    border-radius: 1rem;\n  }\n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    width: 18px;\n    // height: 18px;\n    min-width: 18px;\n    font-size: 11px;\n    padding: 0px;\n    line-height: 19px;\n  }\n  .react-datepicker__current-month,\n  .react-datepicker-time__header,\n  .react-datepicker-year-header {\n    font-size: 14px;\n  }\n\n  .order-datatable-filter-container {\n    display: flex;\n    gap: 8px;\n    justify-content: flex-end;\n    align-items: center;\n    @media (max-width: 600px) {\n      flex-wrap: wrap;\n    }\n  }\n  .custom-modalbackdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(\n      0,\n      0,\n      0,\n      0.5\n    ); /* Customize the backdrop color and opacity */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .OrderCard-main-container {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    justify-content: center;\n    padding: 0;\n    @media (max-width: 767px) {\n      flex-wrap: wrap;\n      gap: 18px;\n    }\n  }\n  .OrderCard-width {\n    width: 24%;\n    @media (max-width: 767px) {\n      width: 48%;\n    }\n    @media (max-width: 600px) {\n      width: 47%;\n    }\n    @media (max-width: 480px) {\n      width: 46%;\n    }\n  }\n  .BookingCard-width {\n    width: 32.5%;\n    @media (max-width: 767px) {\n      width: 31%;\n    }\n    @media (max-width: 600px) {\n      width: 30%;\n    }\n    @media (max-width: 480px) {\n      width: 99%;\n    }\n  }\n  .reminder-history-box {\n    // padding: 6px 12px;\n    height: 150px;\n    min-height: 120px;\n    overflow: auto;\n    border-radius: 3px;\n    padding: 3px 6px;\n    &-single {\n      margin-bottom: 12px;\n      &-para {\n        background: #f2f3f4;\n        padding: 3px 8px;\n        border-radius: 7px;\n        margin: 0;\n        font-size: 13px;\n        font-weight: 400;\n        line-height: 22px;\n        color: #939393;\n        display: inline-block;\n      }\n      &-info {\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        &-show {\n          font-size: 10.5px;\n          line-height: 18px;\n          color: #515151;\n          font-weight: 400;\n        }\n      }\n    }\n  }\n  .reminder-text-editor {\n    height: 60px !important;\n    min-height: 50px;\n    border: 1px solid #cccccc45;\n    border-radius: 3px;\n    display: flex;\n    &:focus {\n      border-color: #e7d896 !important;\n      box-shadow: 0 0 0 0.25rem rgb(231 216 150 / 40%);\n      outline: none;\n    }\n    &-box {\n      width: 100%;\n      height: 100%;\n      padding: 5px;\n      border: none;\n      outline: none;\n      font-size: 15px;\n      color: #474747;\n    }\n    &-submit-btn {\n      height: 30px;\n      margin: auto 5px 5px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      font-size: 21px;\n      border-radius: 4px;\n    }\n  }\n  .reminder-head {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 20px;\n    & p {\n      font-size: 17px;\n      @media (max-width: 767px) {\n        font-size: 17px;\n      }\n      @media (max-width: 500px) {\n        font-size: 16px;\n      }\n    }\n    @media (max-width: 767px) {\n      gap: 8px;\n    }\n  }\n  .customer-reminder {\n    height: 200px;\n    min-height: 100px;\n    &-table {\n      border-collapse: collapse;\n      width: 100%;\n      border-spacing: 0;\n      thead {\n        position: sticky;\n        top: 0;\n      }\n      th{\n        padding: 8px;\n        text-align: left;\n        border: none;\n        font-size: 13px !important;\n        font-weight: 500;\n        text-transform: uppercase;\n        color: #0f1114;\n        white-space: nowrap;\n        @media (max-width: 500px) {\n          font-size: 12px !important;\n          font-weight: 500;\n        }\n      }\n      td {\n        padding: 8px;\n        text-align: left;\n        border: none;\n        white-space: nowrap;\n        padding: 6px 6px;\n        font-size: 12px;\n        white-space: nowrap;\n      } \n    }\n  }\n  .setting-main-box {\n    &-header {\n      padding-left: 20px;\n      .nav-pills .nav-link.active, .nav-pills .show>.nav-link {\n        color: #000;\n        background-color: #e7d993;\n        border: none;\n        border-bottom: 2px solid #e7d993;\n      }\n      &-toggle-btn {\n        padding: 6px;\n        font-size: 15px;\n        font-weight: 500;\n        border-radius: 0 !important;\n        border: none;\n        background-color: #fff;\n        color: #000;\n        margin: 0;\n        border-bottom: 2px solid #e7d993;\n        text-decoration: none;\n        width: 120px;\n        text-align: center;\n        &:focus, &:hover {\n          color: #000;\n        }\n        @media (max-width: 450px) {\n          width: 90px;\n          min-width: 70px;\n        }\n      }\n    }\n\n    &-body {\n      &-card-box {\n        &-heading {\n\n        }\n        &-subBody {\n          display: flex;\n          justify-content: flex-start;\n          align-items: center;\n          gap: 16px;\n          padding-left: 15px;\n          .setting-form-label {\n            font-size: 14px;\n            color: #5b5959;\n            font-weight: 500;\n            white-space: nowrap;\n            @media (max-width: 767px) {\n                font-size: 12px;\n                text-align: start;\n                width: 100%;\n            }\n          }\n          @media (max-width: 767px) {\n            flex-direction: column;\n            gap: 3px;\n          }\n          .setting-key-update-btn {\n            width: 100px;\n            min-width: 60px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            @media (max-width: 450px) {\n              margin-top: 15px;\n              width: 100%;\n            }\n          }\n\n        }\n      }\n    }\n  }\n  .setting-form-imput-box {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    @media (max-width: 767px) {\n      flex-direction: column;\n      margin-bottom: 10px;\n      gap: 2px;\n    }\n  }\n  .pnl-com-show-field {\n    padding: 6px 10px;\n    &-para {\n      font-size: 18px;\n      font-weight: 500;\n      line-height: 22px;\n      margin: 0;\n      padding-left: 10px;\n      display: flex;\n      justify-content: flex-end;\n      width: 50%;\n      @media (max-width: 500px) {\n        font-size: 14px;\n        line-height: 18px;\n        width: 50%;\n        padding-left: 10px;\n      }\n      @media (max-width: 400px) {\n        width: 65%;\n      }\n    }\n    &-amount {\n      font-size: 18px;\n      font-weight: 500;\n      line-height: 22px;\n      margin: 0;\n      padding-left: 10px;\n      width: 50%;\n      @media (max-width: 500px) {\n        font-size: 14px;\n        line-height: 18px;\n        width: 50%;\n      }\n      @media (max-width: 400px) {\n        width: 35%;\n      }\n    }\n  }\n  .transfer-car-amount-box {\n    width: 85%;\n    &-para {\n      width: 50%;\n    }\n    &-show {\n      width: 65%;\n    }\n  }\n  .hour-car-amount-box {\n    width: 85%;\n    &-para {\n      width: 50%;\n    }\n    &-show {\n      width: 65%;\n    }\n  }\n}\n\n.otp-com-input {\n  width: 20%;\n  padding: 5px 8px !important;\n  text-align: center !important;\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n   -webkit-appearance: none;\n}\n.paid-label {\n  background: #0d790d;\n  color: #Fff;\n  text-align: center;\n  width: 64px;\n  border-radius: 10px;\n  height: 21px;\n  padding: 2px 10px;\n}\n.unpaid-label {\n  background: #f14e4e;\n  color: #Fff;\n  text-align: center;\n  width: 64px;\n  border-radius: 10px;\n  height: 21px;\n  padding: 2px 10px;\n}\n.pending-label {\n  background: #f9c242;\n  color: #Fff;\n  text-align: center;\n  width: 64px;\n  border-radius: 10px;\n  height: 21px;\n  padding: 2px 10px;\n}\n.ready-label {\n  background: #4259f9;\n  color: #Fff;\n  text-align: center;\n  width: 64px;\n  border-radius: 10px;\n  height: 21px;\n  padding: 2px 10px;\n}\n.pickup-label {\n  background: #42f95e;\n  color: #Fff;\n  text-align: center;\n  width: 64px;\n  border-radius: 10px;\n  height: 21px;\n  padding: 2px 10px;\n}\n.notaccept-label{\n  background: #f1794e;\n  color: #Fff;\n  text-align: center;\n  width: 64px;\n  border-radius: 10px;\n  height: 21px;\n  padding: 2px 10px;\n}\n.aftertime-label{\n  background: #8522ef;\n  color: #Fff;\n  text-align: center;\n  width: 64px;\n  border-radius: 10px;\n  height: 21px;\n  padding: 2px 10px;\n}\n.refunded-label{\n  background: #4ee3f1;\n  color: #Fff;\n  text-align: center;\n  width: 64px;\n  border-radius: 10px;\n  height: 21px;\n  padding: 2px 10px;\n}\n.accept-label{\n  background: #f942d1;\n  color: #Fff;\n  text-align: center;\n  width: 64px;\n  border-radius: 10px;\n  height: 21px;\n  padding: 2px 10px;\n}\n.main-header-right-user-img {\n  width: 33px;\n  height: 33px;\n  min-width: 33px;\n  & > img {\n    width: 100%;\n    height: 100%;\n    border-radius: 50px;\n    object-fit: cover;\n  }\n}\n .rolebackground{\n  color:#03a9f4 !important;\n }\n .orderbackground{\n  color:#ff9800 !important;\n }\n .staffbackground{\n  color:#3f51b5 !important;\n }\n .assignbackground{\n  color:#34af39 !important;\n }\n.loader {\n  z-index: 999;\n  height: 100vh;\n  width: 100vw;\n  background-color: rgb(26 37 69);\n  img {\n    width: 100px;\n    z-index: 1;\n    animation: loaderLogo 2s infinite linear;\n    @keyframes loaderLogo {\n      0% {\n        transform: rotateY(0deg);\n      }\n      100% {\n        transform: rotateY(360deg);\n      }\n    }\n  }\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n::-webkit-scrollbar-thumb {\n  background-color: #a6aab5;\n  border-radius: 20px;\n}\n.main-sidebar-menu-dropdown a {\n  text-decoration: none;\n}\n.text-black{\n  color:#000;\n}\n.lettercapital{\n  text-transform: capitalize;\n}\n.surge-car-amount-box-show,.meet-car-amount-box-show{\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n.border-danger__control{\n   border:\"1px solid red\"\n}\n#Trackdrivermodal .modal-content{\n  width:750px;\n}\n.trackdriver-btn{\n  background-color: #0025ff  !important;\n}\n.copylinkbtn{\n  background-color: #9c00cc !important;\n  \n}\n.addcalendarbtn{\n  background-color: #007acc !important;\n}\n.editcustomerdetailsbtn{\n  background-color: #7c5aff !important;\n\n}\ndiv.pac-container.pac-logo {\n  z-index: 9999 !important;\n}\n.orderdate-div{\n  height: 36px;\n    border-radius: 13px;\n    background: #ffffff;\n}\n.orderdate-div .dateranger{\n  height: 35px !important;\n}\n.custom-full-width-date-time-picker .react-datepicker-wrapper {\n  width: 100%;\n}\n\n.custom-full-width-date-time-picker .react-datepicker-wrapper .react-datepicker__input-container input {\n  width: 100%;\nborder: 1px solid rgba(204, 204, 204, 0.2705882353);\n  padding: 8px;\n}\n\n.rc-time-picker-clear{\n  display:none;\n}\n.rc-time-picker-input{\n  width: 100%;\n  height: 40px;\n  padding: 8px;\n}\n.manualpaymentbtn{\n  background-color: #ff9595 !important;\n}\n\n\n","\n\n$golden-color : #e7d993;\n$dark-color : #070f1c;\n$white-color : #fff;\n$gray-color: #a9b0b3;\n$sidebarWidth: 250px;\n$headerHeight: 70px;\n$hoverbg: #f0f4ff;\n$mainBlue: #12265f;\n$dangerRed: #FF6961;\n$orange:  #fd7e14;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
